/* eslint-disable indent */
import React, { useCallback } from 'react'
import {
  bindPopover,
  bindTrigger,
  usePopupState
} from 'material-ui-popup-state/hooks'
import Menu from './menu'
import { useTheme } from '@mui/material'

const MenuButton = ({ id, button, disableActiveState }) => {
  const theme = useTheme()
  const buttonId = `${id}-button`
  const menuId = `${id}-menu`
  const popupState = usePopupState({
    variant: 'popover',
    popupId: menuId
  })

  /**
   * Close the menu without invoking the onClick for the menu button
   * which would re-open the menu again.
   */
  const handleClickCapture = useCallback(
    evt => {
      if (popupState.isOpen) {
        evt.stopPropagation()
        popupState.close()
      }
    },
    [popupState]
  )

  const handleClose = useCallback(
    evt => {
      popupState.close(evt)
    },
    [popupState]
  )

  const menuButton = React.cloneElement(button, {
    id: buttonId,
    ...bindTrigger(popupState),
    onClickCapture: handleClickCapture,
    ...(popupState.isOpen &&
      !disableActiveState && {
        style: { backgroundColor: theme.palette.secondaryGrey.shade[5] }
      })
  })

  return (
    <>
      {menuButton}
      <Menu
        {...bindPopover(popupState)}
        onClose={handleClose}
        aria-labelledby={buttonId}
      />
    </>
  )
}

export default MenuButton
